import { z } from 'zod';
import {
  DraftStatusSchema,
  ProcedureIdSchema,
  SignatureDataUrlSchema,
  UserIdSchema,
} from './common';

export const ItemKindSchema = z.enum(['insumo', 'medicamento']);
export type ItemKind = z.infer<typeof ItemKindSchema>;

export const ExpenseLineSchema = z.object({
  codigo: z.string().min(2).max(20),
  nombre: z.string().min(2).max(200),
  tipo: ItemKindSchema,
  cantidad: z.number().min(0).max(10_000),
  unidad: z.string().max(20).optional(),
  observaciones: z.string().max(300).optional(),
});
export type ExpenseLine = z.infer<typeof ExpenseLineSchema>;

export const ExpenseSheetSchema = z.object({
  procedimientoId: ProcedureIdSchema,
  enfermeraId: UserIdSchema,
  lineas: z.array(ExpenseLineSchema).max(200),
  observaciones: z.string().max(2000).optional(),
  /** `borrador` (preguardado) o `firmado` (final). */
  estado: DraftStatusSchema,
  /** Nula mientras es borrador; presente al firmar. */
  firmaEnfermera: SignatureDataUrlSchema.nullable(),
  /** Nula mientras es borrador; timestamp del servidor al firmar. */
  firmadoEn: z.string().datetime().nullable(),
});
export type ExpenseSheet = z.infer<typeof ExpenseSheetSchema>;

/** Firma (final): la firma de la enfermera es OBLIGATORIA. */
export const SignExpenseSchema = ExpenseSheetSchema.omit({
  estado: true,
  firmadoEn: true,
}).extend({
  firmaEnfermera: SignatureDataUrlSchema,
});
export type SignExpenseInput = z.infer<typeof SignExpenseSchema>;

/** Preguardado (borrador): mismo contenido pero SIN exigir la firma. */
export const SaveExpenseDraftSchema = ExpenseSheetSchema.omit({
  estado: true,
  firmadoEn: true,
  firmaEnfermera: true,
});
export type SaveExpenseDraftInput = z.infer<typeof SaveExpenseDraftSchema>;

/** Item del catálogo (insumo o medicamento). */
export const CatalogItemSchema = z.object({
  codigo: z.string().min(2).max(20),
  nombre: z.string().min(2).max(200),
  tipo: ItemKindSchema,
  activo: z.boolean().default(true),
});
export type CatalogItem = z.infer<typeof CatalogItemSchema>;
